// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}


(function () {
    if(innerWidth > 600){
        const images = document.querySelectorAll('.gallery-quad__image img');
        new Ukiyo(images,{
            scale: 1.2,
            speed: 1.5,
            willChange: true
        });
    }

    $(document).ready(function () {

        // Main Nav Dropdown
        $("#primary-nav li").hover(function () {
            $(this).addClass("hover");
            $('ul.submenu', this).fadeIn(200);
        }, function () {
            $(this).removeClass("hover");
            $('ul.submenu', this).fadeOut(200);
        });

        //dropdown for mobile
        if(document.querySelector('.menu-responsive')){
            document.querySelectorAll('.inner > ul > li > a').forEach(link => {
                link.addEventListener('click', (e) => {
                    console.log('here');
                    if (link.nextSibling.nextSibling != null) {
                        document.querySelectorAll('.inner > ul > li').forEach(item => {
                            if (link.parentNode !== item) item.classList.remove('js-submenu-show');
                        });
                        //remove this comment if you want show subnav for mobile
                        e.preventDefault();
                        link.parentNode.classList.toggle('js-submenu-show');
                    }
                });
            });
        }

    });

    document.addEventListener("DOMContentLoaded", function() {
        const header = document.querySelector("header");
        let lastScrollY = window.scrollY;
    
        function updateHeader() {
            const currentScrollY = window.scrollY;
    
            if (currentScrollY === 0) {
                header.classList.remove("down", "up");
            } else if (currentScrollY > lastScrollY) {
                header.classList.remove("up");
                header.classList.add("down");
            } else {
                header.classList.remove("down");
                header.classList.add("up");
            }
    
            lastScrollY = currentScrollY;
        }
    
        window.addEventListener("scroll", updateHeader);
    });

    document.addEventListener("DOMContentLoaded", function() {
        let url = window.location.href;
        if (url.includes("#")) {

            let id = url.split("#")[1];
            if(id){
                window.scrollTo(0,0);
            }
            let element = document.getElementById(id);

            if (element) {
                element.click();
                setTimeout(function () {
                    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }, 500);
            } else {
                console.error('no element found');
            }
        }
    });

    document.addEventListener("DOMContentLoaded", function() {
        let current_url = window.location.search;
        if( current_url && current_url.includes("menu") ){
            let id_from_current_url = current_url.split('=')[1];
            
            let element_on_DOM = document.getElementById(id_from_current_url);

            if (element_on_DOM) {
                element_on_DOM.click();
                setTimeout(function () {
                    element_on_DOM.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }, 500);
            } else {
                console.error('no element found');
            }
        }
    });

    /*window.onload = function () {
        if(!document.getElementById('reset')){
            scrollDownAction(40, 'scroll');
            
            scrollW();
            window.addEventListener('scroll', function () {
                scrollW();
            });
        }



        var data = document.URL;

        if(data.indexOf("#") != -1){
            let dataFilter = data.split('#')[1];
            let target = document.querySelector('#'+ dataFilter);
            let headerHeight = document.querySelector('header').offsetHeight;

            // setTimeout(() => {
            //     window.scrollTo({
            //         top: target.offsetTop - headerHeight,
            //         behavior: 'smooth'
            //     });
            // }, 500);
        }

    };*/

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach(e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: true
    });

    $('.gallery-quad__slider').slick({
        arrows: false,
        dots: true,
        slide: '.slide-gallery',
        fade: true,
        speed: 700,
        accessibility: true
    });

    $('.history__slider').slick({
        arrows: true,
        dots: false,
        fade: true,
        speed: 700,
        accessibility: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    arrows: false,
                    dots: true
                }
            }
        ]
    });

    $('.slider__slider').slick({
        arrows: true,
        dots: false,
        fade: true,
        speed: 1000,
        accessibility: true
    });

    $('.single-quad-gallery__slider').slick({
        arrows: true,
        dots: false,
        fade: true,
        speed: 1000,
        accessibility: true
    });


    if (document.getElementsByClassName('js-accordion-title')) {
        document.querySelectorAll('.accordion').forEach((accordion) => {
            accordion.querySelectorAll('.js-accordion-title').forEach((itemHead) => {
                itemHead.addEventListener('click', (e) => {
                    accordion.querySelectorAll('.js-accordion-item').forEach((item) => {
                        if (itemHead.parentNode !== item) item.classList.remove('open');
                    });
                    itemHead.parentNode.classList.toggle('open');
                });
            });
        });
    }

    //CMS forms label animation
    if (document.getElementsByClassName('form-module__field').length > 0) {
        let allffields = document.getElementsByClassName('form-module__field');

        for (let j = 0; j < allffields.length; j++) {

            if (allffields[j].getElementsByTagName('input').length > 0) {
                if (allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio') {
                    allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function () {
                        this.parentElement.classList.add('moved');
                    })
                }
            }
            if (allffields[j].getElementsByTagName('select').length > 0) {
                allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function () {
                    this.parentElement.classList.add('moved');
                })
            }
            if (allffields[j].getElementsByTagName('textarea').length > 0) {
                allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function () {
                    this.parentElement.classList.add('moved');
                })
            }
        }
    }
    
    if (document.querySelector('.js-btn-join-us')) {
        document.querySelectorAll('.js-btn-join-us').forEach((btn) => {
            btn.addEventListener('click', () => {
                window.open("https://clubninetysix.buk.mx/trabaja-con-nosotros");
            })
        })
    }

    if (document.querySelector('.js-btn-member')) {
        document.querySelectorAll('.js-btn-member').forEach((btn) => {
            btn.addEventListener('click', () => {
                document.getElementById('member-login').classList.add('show');
            })
        })
    } 

    if (document.querySelector('.js-close-login')) {
        document.querySelectorAll('.js-close-login').forEach((btn) => {
            btn.addEventListener('click', () => {
                document.getElementById('member-login').classList.remove('show');
            })
        })
    }
    
    if (document.querySelector('.js-open-menu')) {
        document.querySelectorAll('.js-open-menu').forEach((btn) => {
            btn.addEventListener('click', () => {
                document.getElementById('menu-responsive').classList.add('show');
            })
        })
    }

    if (document.querySelector('.js-close-menu')) {
        document.querySelectorAll('.js-close-menu').forEach((btn) => {
            btn.addEventListener('click', () => {
                document.getElementById('menu-responsive').classList.remove('show');
            })
        })
    }

    if (document.querySelector('.text-modules-wrapper')) {
        document.querySelectorAll('.text-modules-wrapper .text-modules').forEach((item) => {
            item.classList.add('animate-fade', 'top');
        });
    }

    if (document.querySelector('.form-module-wrapper ')) {
        document.querySelectorAll('.form-module-wrapper  .form-module').forEach((item) => {
            item.classList.add('animate-fade', 'top');
        });
    }

    if (document.querySelector('.global-sitemap')) {
        document.querySelector('.global-sitemap').classList.add('animate-fade', 'top');
    }

    // if(document.getElementById('attractions-wrapper')){
    //     setTimeout(() => {
    //         document.querySelectorAll('#attractions-wrapper .attraction .attraction__info .description').forEach((text)=>{
    //             let textBox = text.innerHTML;
    //             textBox = textBox.substring(0, 220) + "...";
    //             text.textContent = textBox;
    //         })
    //     }, 500);
    // }

    if(document.querySelector('.forgot-pass')){
        document.querySelectorAll('.js-show-forgot').forEach((button)=>{
            button.addEventListener('click', (e)=>{
                e.preventDefault;
                document.getElementById('forgotContainer').classList.add('show');
                document.getElementById('loginForm').classList.add('hidde');
            })
        })
    }

    if(document.querySelector('.forgot-pass')){
        document.querySelectorAll('.js-show-log').forEach((button)=>{
            button.addEventListener('click', (e)=>{
                e.preventDefault;
                document.getElementById('forgotContainer').classList.remove('show');
                document.getElementById('loginForm').classList.remove('hidde');
            })
        })
    }

    if(document.querySelector('.menus-quad__filter')){
        document.querySelectorAll('.menus-quad').forEach((quad)=>{
            let menuTab = quad.querySelectorAll('.menus-quad__filter li');
            let menus = quad.querySelectorAll('.menus-quad__menu');
            let lastClick = null;
    
            menuTab.forEach((tab)=>{
                tab.addEventListener('click',(e)=>{
                    let data = e.target.dataset.tag;
                    if(lastClick){
                        lastClick.classList.remove('active');
                    }
                    tab.classList.add('active');
                    menus.forEach((item)=>{
                        item.classList.toggle('hidden',item.dataset.tag != data);
                    });
                    lastClick = tab;
                })
            })
            menuTab[0].click();
        })
    }

    if(document.querySelector('.menus-quad__select')){

        document.querySelectorAll('.menus-quad').forEach((quad)=>{
            let selectMenu = quad.querySelector('.select_menu');
            let menus = quad.querySelectorAll('.menus-quad__menu');

            selectMenu.addEventListener('change',(e)=>{
                let data = selectMenu.value;
                menus.forEach((item)=>{
                    item.classList.toggle('hidden',item.dataset.tag != data);
                });
            });
    
            let eventChange = new Event("change");

            selectMenu.dispatchEvent(eventChange);

            let eventClick = new Event("click");
            selectMenu.dispatchEvent(eventClick);

        })
    }

    
    
})();



function scrollW() {
    //check scroll down or up for header styles
    let st = window.pageYOffset || document.documentElement.scrollTop;
    if (st > 40) {
        if (st > lastScrollTop) {
            // downscroll code
            if (!document.getElementById('header').classList.contains('down')) {
                document.getElementById('header').classList.add('down');
                document.getElementById('header').classList.remove('up');
            }
        } else {
            // upscroll code
            if (!document.getElementById('header').classList.contains('up')) {
                document.getElementById('header').classList.add('up');
                document.getElementById('header').classList.remove('down');
            }
        }
    } else {
        if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
            document.getElementById('header').classList.remove('up');
            document.getElementById('header').classList.remove('down');
        }
    }
    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

function loginMembers(e) {
    e.preventDefault();

    let extras = {}, formId = "loginForm",url = "/ajax/functions.php",formData = new FormData();
    clearErrors(formId);
    formProcessSetup(formId);

    formData.append('operation', 'loginMembers');
    formData.append('username_member', document.getElementById("username_member").value);
    formData.append('password_member', document.getElementById("password_member").value);
    //formData.append('remember', document.getElementById("remember").checked);

    fetch(url, {
        method: 'POST',
        body: formData
    }).then(response => response.json())
        .then(data => {
        if (data.result === 'success') {
            localStorage.setItem("username", data.name);
            extras.page_redirect = '/';
            if (data.warning === 1)
                localStorage.setItem('msg', 1);
            showResult(data, formId, extras);
        } else {
            showErrors(data, formId, extras);
        }
    }).catch(error => console.error('Error:', error));
}

function processRecovery(e){
	e.preventDefault();
	var extras = {},formId = "forgotForm",url = "/ajax/functions.php",formData = new FormData();
	clearErrors(formId);
	formProcessSetup(formId);
    formData.append('operation', 'processRecovery');
    formData.append('email_forgot', document.getElementById("email_member").value);
    
    fetch(url, {
        method: 'POST',
        body: formData
    }).then(response => response.json())
        .then(data => {
        if (data.result === 'success') {
            document.getElementById("forgotForm").classList.add('hidden');
            document.querySelector(".forgotForm__success").classList.remove('hidden');
            showResult(data, formId, extras);
        } else {
            showErrors(data, formId, extras);
        }
    }).catch(error => console.error('Error:', error));

}

function activeAccount(e){
	e.preventDefault();
    var extras = {},formId = 'activeForm',url = '/ajax/functions.php',formData = new FormData();
	extras.dont_hide_form = "1";
    extras.dont_reset_form = "1";

    $("#processing").show();
	$("#btnSubmit").hide();
	
	$('.errorMsg').slideUp();
    $(".errorMsg").html('');

    clearErrors(formId);
    formProcessSetup(formId);

    formData.append('operation', 'activeAccount');
    formData.append('email_reset', document.getElementById("email_reset").value);
    formData.append('token', document.getElementById("token").value);
    formData.append('password_reset', document.getElementById("password_reset").value);
    formData.append('confirm_password', document.getElementById("confirm_password").value);

    fetch(url, {
        method: 'POST',
        body: formData
    }).then(response => response.json())
        .then(data => {
        if (data.result === 'success') {
            document.getElementById("email_reset").value='';
            document.getElementById("password_reset").value='';
            document.getElementById("confirm_password").value='';
            $('#activeForm .errorMsg').slideDown();
            $(".errorMsg").html('Thank you. Your password has been reset. Please save this password for your records.');
            
            extras.page_redirect = "index.php";
            setTimeout(()=>{
                showResult(data,formId,extras);
            },4000);
        } else {
            showErrors(data, formId, extras);
        }
        $("#processing").hide();
    }).catch(error => console.error('Error:', error));
}

function showResult(data, formId, extras) {
    /*extras parameters:
        dont_reset_form = if set will not reset the form
        dont_hide_form = if set will not hide the form
        skip_parent_errors = if set errors will not be placed on the parent elements
        step_content = if set will load up the content  into div
        page_redirect = if set will redirect to the page passed on success
        function_name = if set will call function on form submit success
        use_exact_path = if set will use exact path passed instead of a SITE_ROOT path
        exact_path = path to use for the above option
        dont_scroll_on_error = if set will not scroll to top of page when theres an error
        dont_scroll_on_success = if set will not scroll to top on success
        scrollto = element id to scroll to instead
        clear_errors = if set will clear errors on the form
        dont_hide_buttons = if set will not hide the buttons, use for nested forms.
    */
    if (extras == undefined) { extras = '' } //check if the extras parameters array exists if not set it so that we dont get errors farther down

    $('#' + formId + ' .errorMsg').slideUp();
    $('#' + formId + ' .errorMsg').html('');

    if (extras.dont_hide_buttons != '1') {
        if ($('#' + formId + ' .processing').length > 0) $('#' + formId + ' .processing').show();
        if ($('#' + formId + ' .btnSubmit').length > 0) $('#' + formId + ' .btnSubmit').hide();
    }

    //check if result is being passed the new way
    var result; //will hold the value for our result success | error

    if (data[0] == undefined) result = data.result;
    else result = data[0].result;

    if (result == "success") {
        if (extras.dont_reset_form != '1') { resetForm(formId); } //if the dont_reset_form is isnt set then reset the form
        if (extras.step_content != undefined) //check if the ajax page parameter is defined
        {
            //alert('load up via ajax: ' + data[1].step_content);
            $("#step_content").hide();	//this has to stay the same because this is where the forms are being loaded into
            $("#step_content").load(SITE_ROOT + extras.step_content, function () {
                _gaq.push(['_trackPageview', extras.step_content]);

                if ($('#' + formId + ' .btnSubmit').length > 0) $('#' + formId + ' .btnSubmit').show();
                if ($('#' + formId + ' .processing').length > 0) $('#' + formId + ' .processing').hide();
                $("#step_content").slideDown();
            }
            );
            if (extras.dont_scroll_on_success != '1') {
                if (extras.scrollto != undefined) {
                    if ($('#fbcontent').length > 0) {
                        $('#fancybox-inner').scrollTo('#' + extras.scrollto, 100, { offset: { top: -20 }, axis: 'y' });
                    } else {
                        $.scrollTo('#' + extras.scrollto, 800, { offset: { top: -20 }, axis: 'y' });
                    }
                }
                else {
                    if ($('#fbcontent').length > 0) {
                        $('#fancybox-inner').scrollTo(0, 100);
                    } else {
                        $.scrollTo(0, 800);
                    }
                }
            }
        }
        else if (extras.page_redirect != undefined) //check if page redirect parameter is passed
        {
            if (extras.use_exact_path == '1') {
                document.location = extras.exact_path;
            }
            else {
                document.location = extras.page_redirect;
            }
        }
        else if (extras.function_name != undefined) {
            eval(extras.function_name)();
        }
        else {
            $(".thankyouMsg").html(data.message);
            if ($('.thankyouMsg').length > 0) $('#' + formId + ' .thankyouMsg').slideDown();
            if ($('#' + formId).prev(".thankyouMsg").length > 0) $('#' + formId).prev(".thankyouMsg").slideDown();

            if (extras.dont_hide_form != '1') {
                if ($('#' + formId).length > 0) $("#" + formId).slideUp();
            }
            else {
                if ($('#' + formId + ' .btnSubmit').length > 0) $('#' + formId + ' .btnSubmit').show();
                if ($('#' + formId + ' .processing').length > 0) $('#' + formId + ' .processing').hide();
            }
            if (extras.dont_scroll_on_success != '1') {
                if (extras.scrollto != undefined) {
                    if ($('#fbcontent').length > 0) {
                        $('#fancybox-inner').scrollTo('#' + extras.scrollto, 100, { offset: { top: -20 }, axis: 'y' });
                    } else {
                        $.scrollTo('#' + extras.scrollto, 800, { offset: { top: -20 }, axis: 'y' });
                    }
                }
                else {
                    if ($('#fbcontent').length > 0) {
                        $('#fancybox-inner').scrollTo(0, 100);
                    } else {
                        window.scrollTo({
                            behavior: 'smooth',
                            left: 0,
                            top: 800,
                        });
                    }
                }
            }
        }
        if (extras.clear_errors == '1') { clearErrors(formId); }
    }
    else {
        showErrors(data, formId, extras);
    }


}

function showErrors(data, formId, extras) {
    clearErrors(formId);

    var newData = new Object();
    if (data[0] == undefined) newData = data;
    else newData = data[0];

    //loop through the JSON array and display the errors
    $.each(newData, function (key, value) {
        if (key != "result") {
            if (extras.add_parent_error != undefined) {
                if ($('#' + key).parent().hasClass("form-entry")) $('#' + key).parent().addClass("error");
            }
            $('label[for=' + key + ']').addClass("error");
            $('#' + key).addClass("error");
            if ($('label[for=' + key + ']').length > 0)
                $('<span id="' + key + '-error" class="msg error" >This field is required.</span>').insertAfter($('label[for=' + key + ']'));
            else
                $('<span id="' + key + '-error" class="msg error" >This field is required.</span>').insertAfter($('#' + key));
        }
    });
    if ($("#" + formId + " .errorMsg").html() == "") {
        //$("#"+formId+" .errorMsg").html("<ul><li>Please correct the errors highlighted in red above.</li></ul>");
        if (newData.errorLogin !== undefined && formId == 'loginForm') {
            $("#" + formId + " .errorMsg").html("<ul><li>" + newData.errorLogin + "</li></ul>");
            if (!$("#username").hasClass('error')) $("#username").addClass('error');
            if (!$("#password").hasClass('error')) $("#password").addClass('error');
        } else if (newData.errorActiveAccount !== undefined && formId == 'activeForm') {
            $("#" + formId + " .errorMsg").html("<ul><li>" + newData.errorActiveAccount + "</li></ul>");
            $('#confirm_password-error').remove();
        } else if (newData.errorProcessRecovery !== undefined && formId == 'forgotForm') {
            $("#" + formId + " .errorMsg").html("<ul><li>" + newData.errorProcessRecovery + "</li></ul>");
            if ($('#email_forgot').val() !== '')
                $('#email_forgot-error').remove();
        } else if (newData.errorRegisterForm !== undefined && formId == 'registerForm') {
            $("#" + formId + " .errorMsg").html("<ul><li>" + newData.errorRegisterForm + "</li></ul>");
        } else if (formId !== 'loginForm' && formId !== 'activeForm' && formId !== 'forgotForm') {
            console.log(formId);
            $("#" + formId + " .errorMsg").html("<ul><li>Please correct the errors highlighted in red above.</li></ul>");
        }

    } else {
        $("#" + formId + " .errorMsg").html("<ul>" + $("#" + formId + " .errorMsg").html() + "</ul>");
    }
    $("#" + formId + " .errorMsg").slideDown();

    if (extras.dont_scroll_on_error != '1') {
        if (extras.scrollto != undefined) {
            if ($('#fbcontent').length > 0) {
                $('#fancybox-inner').scrollTo('#' + extras.scrollto, 100, { offset: { top: -20 }, axis: 'y' });
            } else {
                //$.scrollTo('#'+extras.scrollto,800,{offset:{top:-20},axis:'y'});
            }
        }
        else {
            if ($('#fbcontent').length > 0) {
                $('#fancybox-inner').scrollTo(0, 100);
            } else {
                //$.scrollTo(0,800);
            }
        }
    }

    if ($('#' + formId + ' .processing').length > 0) $('#' + formId + ' .processing').hide();
    if ($('#' + formId + ' .btnSubmit').length > 0) $('#' + formId + ' .btnSubmit').show();
}


function clearErrors(formId)  //safari bug is here!!
{
    $('input[type="text"],input[type="password"],input[type="radio"],textarea,select').removeClass("error");
    $('#' + formId + ' label').each(function (index) {
        if (!$(this).hasClass('errorMsg')) $(this).removeClass("error");
    });

    $('#' + formId + ' span').each(function (index) {
        if ($(this).hasClass('msg error')) $(this).remove();
    });

}

function resetForm(formId) {
    //$('[type="text"]').val("");
    $('#' + formId + ' textarea').val("");
    $(':input', '#' + formId)
        .not(':button, :submit, :reset, :hidden, :checkbox , :radio')
        .val('')
        .removeAttr('checked')
        .removeAttr('selected');

    clearErrors(formId);
}
function formProcessSetup(formId) {
    $('#' + formId + ' .errorMsg').slideUp();
    $('#' + formId + ' .errorMsg').html('');

    if ($('#' + formId + ' .processing').length > 0) $('#' + formId + ' .processing').show();
}